<script setup lang="ts">
import { ref, computed, onMounted, onUnmounted, nextTick, watch } from 'vue';
import { PopupButton } from '@tma.js/sdk-vue';
import router from '@/router';
import { useStore } from 'vuex';
import { useRoute } from "vue-router";
import ShopItem from '@/components/mobile/telegram/shop_components/ShopItem.vue';
import Product from '@/models/product';
import { getProductsByPoint } from '@/composables/itemWorker';
import { setBottomButton, hideBottomButton, setBackButton, hideBackButton } from '@/tools/setTelegramButtons';
import { setHaptic } from '@/tools/setTelegramHaptick';
import iconMapping from '@/models/iconmapping';
import categories from '@/models/productsCategories';
import Point from '@/models/point';
import SelectPoint from '@/components/mobile/telegram//selected_point_components/SelectPoint.vue';
import AnimatePlaceHolder from '@/components/mobile/telegram/AnimatePlaceHolder.vue';

const mainButtonPressed = () => {
  setHaptic();
  router.push(`/cart?point_uuid=${point_uuid.value}&point_id=${point_id.value}`);
}

const store = useStore();
const points = ref<Point[]>(store.getters.getAllPoints);
const products = ref<Product[] | null>(null);
const point_uuid = ref();
const point_id = ref();
const editRef = ref(false);
const search = ref(false);
const searchQuery = ref('');
const selectedCategory = ref('Продукты');
const respIsResieved = ref<boolean>(false);
const openModalSelectPoint = ref<Boolean>(false);
const searchInput = ref<HTMLInputElement | null>(null);

const delBarcodes = [
  'f63922ea-27c9-4fa0-bc45-4e2c1f43236a',
  '81e1f6bb-f7ac-4f4c-8add-2f81446a182b',
  'ffe33067-f016-4f4f-8444-ccc26b73aa10',
  'b6a33352-a391-42d7-b27f-22e3b4581ac5',
  'c8ea1239-b1f5-4cfc-933e-9524ad974452',
  'c7a08602-93e6-465f-8776-c0e64328f86c'
];

const delSet = new Set(delBarcodes);

async function getAllProducts() {
  products.value = await getProductsByPoint(point_uuid.value);

  products.value?.forEach((product: Product) => {
    if (Array.isArray(product.packaging)) {
      product.packaging = product.packaging.filter(
        (pkg) => !delSet.has(pkg.id)
      );
    }
  });

  respIsResieved.value = true;
}

onMounted(async () => {
  setBackButton();
  if (productsInCart.value.length > 0) {
    setBottomButton('Корзина', '31B545', 'FFFFFF', mainButtonPressed)
  }
  point_uuid.value = String(useRoute().query.point_uuid);
  point_id.value = Number(useRoute().query.point_id);
  await getAllProducts();
  document.addEventListener('click', handleClickOutside);
})

onUnmounted(() => {
  hideBackButton();
  hideBottomButton();
});

const currentPoint = computed(() => {
  return points.value.find((point: Point) => point.id === point_id.value) ?? null
})

async function selectPoint(point: Point) {

  //Всё что ниже актуально будет только для корзины
  // if (productsInCart.value.length > 0) {
  //   let buttons: PopupButton[];
  //   buttons = [
  //     {
  //       id: 'yes',
  //       text: 'Да',
  //       type: 'default'
  //     },
  //     {
  //       id: 'no',
  //       text: 'Нет',
  //       type: 'default'
  //     }
  //   ];
  //   const allCartsByPoints: {pointId: number, items: any}[] = store.getters.getCartByPoints;
  //   let isMerge = allCartsByPoints.some(point => point.pointId === newpPoint.id);
  //   if (isMerge) {
  //     popupManager.openPopup(`Объединить текущую корзину (${currentPoint.value?.name}) с корзиной на точке ${newpPoint.name}`,
  //       async (buttonId) => {
  //         if (buttonId === 'yes') {
  //           store.dispatch('moveCartToPoint', {
  //             fromPointId: currentPoint.value?.id,
  //             toPointId: newpPoint.id,
  //             merge: true
  //           });
  //           popupManager.cleanup();
  //           syncNewPoint(newpPoint);
  //         }
  //         if (buttonId === 'no') {
  //           store.dispatch('moveCartToPoint', {
  //             fromPointId: currentPoint.value?.id,
  //             toPointId: newpPoint.id,
  //             merge: false
  //           });
  //           popupManager.cleanup();
  //         } 
  //       }, buttons
  //     )
  //   } else {
  //     popupManager.openPopup(`Перенести собранную корзину на точку ${newpPoint.name}`,
  //       async (buttonId) => {
  //         if (buttonId === 'yes') {
  //           popupManager.cleanup();
  //           store.dispatch('moveCartToPoint', {
  //             fromPointId: currentPoint.value?.id,
  //             toPointId: newpPoint.id,
  //             merge: true
  //           });
  //           syncNewPoint(newpPoint);
  //         }
  //         if (buttonId === 'no') {
  //           popupManager.cleanup();
  //         } 
  //       }, buttons
  //     )
  //   }
  // }
  localStorage.setItem('selectedPoint', JSON.stringify(point));
  store.dispatch('setSelectedPoint', point);
  point_uuid.value = point.uuid;
  point_id.value = point.id;
  respIsResieved.value = false;
  setTimeout(() => {
    choosePoint();
  }, 100)
  await getAllProducts();
}

const filteredProducts = computed(() => {
  return (products.value ?? [])
    .filter((product: Product) => {
      const forLog = product.description.split(';').map(item => item.trim());
      const matchesCategory = forLog.find(item => item === selectedCategory.value)
      return matchesCategory;
    })
    .map((product: Product) => ({
      ...product,
      icon: iconMapping[product.description] || product.icon || ''
    }));
});

const filteredProductsForSearch = computed(() => {
  return (products.value ?? [])
    .filter((product: Product) => {
      const searchText = searchQuery.value?.toLowerCase() || '';
      const forLog = product.description.split(';').map(item => item.trim());
      const matchesSearch =
        (product.name?.toLowerCase().includes(searchText) ?? false) ||
        (product.description?.toLowerCase().includes(searchText) ?? false);
      return forLog && matchesSearch;
    })
    .map((product: Product) => ({
      ...product,
      icon: iconMapping[product.description] || product.icon || ''
    }));
});

function openSearch() {
  search.value = !search.value;
  if (search.value === true) {
    focusInput();
  } else {
    searchQuery.value = '';
  }
}

function choosePoint() {
  openModalSelectPoint.value = !openModalSelectPoint.value
}

const focusInput = async () => {
  await nextTick();
  if (searchInput.value) {
    searchInput.value.focus();
  }
};

watch(search, (newVal) => {
  if (newVal) {
    focusInput();
  }
});

onMounted(() => {
  if (search.value) {
    focusInput();
  }
});

const handleClickOutside = (event: MouseEvent) => {
  const target = event.target as HTMLElement;
  const searchWrapper = target.closest('.search-wrapper');
  if (!searchWrapper && searchInput.value) {
    searchInput.value.blur();
  }
};

const productsInCart = computed(() => store.getters.getCartItemsByPoint(currentPoint.value?.id) ?? []);

watch(() => productsInCart.value, (newVal) => {
  console.log('productsInCart newVal=', newVal)
  if (newVal.length > 0) {
    setBottomButton('Корзина', '31B545', 'FFFFFF', mainButtonPressed)
  } else {
    hideBottomButton();
  }
}, {immediate: true})

</script>

<template>

  <Transition name="fade">
    <div class="background-blur-choose-point" v-if="openModalSelectPoint" @click="choosePoint()"></div>
  </Transition>
  <Transition name="slideUp">
    <SelectPoint v-if="openModalSelectPoint"
      :points="points"
      :selectedPoint="currentPoint"
      @selectPoint="selectPoint"
      @closeModal="choosePoint()"
    />
  </Transition>
  <Transition name="fade">
    <div class="search-wrapper" v-if="search" style="overflow: scroll;">
      <div class="search__input">
        <input 
          ref="searchInput"
          v-model="searchQuery"
          class="text"
          id="msg"
          type="text"
          placeholder="Поиск..."
        />
        <p class="search__close" @click="openSearch()">Отмена</p>
      </div>
      <div
        v-if="filteredProductsForSearch.length > 0 && searchQuery !== ''"
        class="shop-items" 
        style="margin-top: 70px; margin-bottom: 10px;"
      >
        <ShopItem v-for="(product, index) in filteredProductsForSearch" 
          :product="product"
          :key="index"
          :id="product.id"
          :name="product.name"
          :description="selectedCategory"
          :packaging="product.packaging"
          :icon="product.icon"
          :point-id="point_id"
        />
      </div>
      <p class="search__label" v-else>Что ищем?</p>
    </div>
  </Transition>

  <div class="shop-wrapper">
    <div class="shop-header">
      <div class="section-scroll">
        <div 
          v-for="(category, id) in categories"
          :key="category.id"
          :class="[category.class, { active: selectedCategory === category.name }]"
          :style="{ color: selectedCategory === category.name ? 'white' : 'black', marginLeft: id === 0 ? '6px' : '0', marginRight: id === categories.length - 1 ? '6px' : '0' }"
          @click="setHaptic(); selectedCategory = category.name"
        >
          {{ category.name.toUpperCase() }}
        </div>
      </div>
    </div>
      <div style="margin-top: 70px;" class="shop-items" v-if="filteredProducts.length > 0 && respIsResieved">
        <ShopItem v-for="(product, index) in filteredProducts" 
          :product="product"
          :key="index"
          :id="product.id"
          :name="product.name"
          :description="selectedCategory"
          :packaging="product.packaging"
          :icon="product.icon"
          :point-id="point_id"
        />
      </div>
      <AnimatePlaceHolder v-else-if="!respIsResieved"
        width="100%"
        height="75vh"
        border-radius="var(--border-radius)"
        style="margin-top: 20px;"
      />
      <p v-else class="no-products">Не нашли ничего похожего</p>
  </div>

  <div class="bottom-section">
    <div class="point-wrapper" @click="choosePoint()">
      <svg style="transform: rotate(-90deg);" width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1.67578 12.1982C1.67578 12.1982 7.1886 7.05294 7.1886 6.68542C7.1886 6.3179 1.67578 1.1726 1.67578 1.1726" stroke="black" stroke-width="1.20513" stroke-linecap="round"/>
      </svg>
      <p>{{ currentPoint?.name }}</p>
    </div>
    <div class="search-icon" @click="setHaptic(); openSearch()">
      <svg width="20px" height="20px" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M17.1434 8.57148C17.1434 13.3054 13.3057 17.143 8.57168 17.143C3.83767 17.143 0 13.3054 0 8.57148C0 3.83758 3.83767 0 8.57168 0C13.3057 0 17.1434 3.83758 17.1434 8.57148ZM1.80604 8.57148C1.80604 12.3079 4.83512 15.337 8.57168 15.337C12.3082 15.337 15.3373 12.3079 15.3373 8.57148C15.3373 4.83501 12.3082 1.806 8.57168 1.806C4.83512 1.806 1.80604 4.83501 1.80604 8.57148Z" fill="black"/>
        <path d="M19.206 20.7959C19.6454 21.2353 20.3577 21.2353 20.7971 20.7959C21.2364 20.3566 21.2364 19.6442 20.797 19.2049L19.206 20.7959ZM13.0834 14.6734L19.206 20.7959L20.797 19.2049L14.6744 13.0824L13.0834 14.6734Z" fill="black"/>
      </svg>
    </div>

  </div>

</template>

<style scoped>

.bottom-section {
  position: fixed;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100vw;
  z-index: 2;
}

.background-blur-choose-point {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 3;
  background-color: #8E8E9290;
  backdrop-filter: blur(10px);
}

.point-wrapper {
  width: 100%;
  padding: 20px 0;
  background-color: var(--grey-color);
  box-sizing: border-box;
  box-shadow: var(--drop-shadow-item);
  z-index: 1;
  border-top-right-radius: var(--border-radius);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.admin-header-edit{
  font-size: 15px;
  color: var(--green-color);
  font-weight: 600;
}

.admin-header-label{
  font-size: 18px;
  color: black;
  font-weight: 600;
}

.admin-header{
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 20px;
}

.shop-items-admin{
  width: 100%;
}

.no-products{
  color: black;
  margin-top: 75px;
  font-size: 20px;
  font-weight: 500;
}

.close-search-icon-wrapper{
  position: absolute;
  display: flex;
  right: 0;
  width: 15%;
  justify-content: end;
  height: 100%;
}

.icon-close-search{
  max-width: 14px;
  margin-right: 30%;
}

input.text::placeholder {
  color: #B9B9B9;
}

input.text {
  background-color: inherit;
  font-size: 16px;
  padding: 0px;
  font-family: inherit;
  margin: 0;
  border: none;
  outline: none;
  width: 100%;
}

.search__label {
  font-size: 18px;
  margin-top: 90px;
  width: 100%;
  text-align: center;
}

.search__close {
  font-size: 15px;
}

.search__input {
  position: fixed;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 20px;
  border-bottom-left-radius: var(--border-radius);
  border-bottom-right-radius: var(--border-radius);
  background-color: white;
  box-sizing: border-box;
}

.search-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 4;
  background-color: #F5F4F2;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  overflow-y: scroll;
  box-shadow: var(--drop-shadow-item);
}

.search-wrapper::-webkit-scrollbar {
  display: none;
}

.active {
  background-color: var(--green-color);
  color: white;
}

.test-btn-cart{
  position: absolute;
  background-color: var(--green-color);
  bottom: 10px;
  color: white;
  padding: 20px 100px;
  border-radius: var(--border-radius);
}

.shop-items{
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  width: 100%;
  margin-top: 20px;
  margin-bottom: 65px;
  gap: 10px;
}

.search-icon{
  display: flex;
  background-color: var(--grey-color);
  padding: 20px;
  border-top-left-radius: var(--border-radius);
  box-shadow: var(--drop-shadow-item);
}

.first-section, .second-section, .third-section, .four-section, .five-section, .six-section, .seven-section, .eight-section, .nine-section, .ten-section{
  font-size: 13px;
  font-weight: 500;
  color: black;
  padding: 10px 13px;
  border-radius: var(--border-radius);
  white-space: nowrap;
}

.section-scroll {
  overflow-x: scroll;
  display: flex;
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.section-scroll::-webkit-scrollbar {
  display: none;
}

.shop-header {
  position: fixed;
  top: 8px;
  left: 8px;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: calc(100vw - 8px);
  gap: 13px;
  padding: 6px 0;
  box-sizing: border-box;
  background-color: white;
  border-radius: var(--border-radius);
  box-shadow: var(--drop-shadow-item);
  overflow: hidden;
}

.shop-wrapper{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
}

</style>
